import { createContext } from 'react'

const StoresContext = createContext({})

export default StoresContext
